import React from 'react';
import { useTranslation } from 'react-i18next';

import { useContentRequestsCount } from '@/administration/store/administration';
import { ADMIN_LINKS } from '@/components/Navbar/consts';
import { StyledAdminDesktopWrapper, StyledNavItem, StyledNavItemNotification } from '@/components/Navbar/styles';
import { useProviderLicensesSummary } from '@/administration/pages/Catalog/utils/queries';
import { ProviderList } from '@/store/providers';

export const NavAdminContent = (): JSX.Element => {
  const { t } = useTranslation('navbar');
  const approvalsCount = useContentRequestsCount();
  const { data: courseraSummary } = useProviderLicensesSummary(ProviderList.COURSERA);

  return (
    <StyledAdminDesktopWrapper>
      {ADMIN_LINKS.map(
        (link) =>
          link.link &&
          !link.onlyMobile && (
            <StyledNavItem to={link.link} key={link.label} className={({ isActive }) => (isActive ? ' selected' : '')}>
              {t(link.label)}
              {link.count && (!!approvalsCount || !!courseraSummary?.pendingLicenses) && <StyledNavItemNotification />}
            </StyledNavItem>
          ),
      )}
    </StyledAdminDesktopWrapper>
  );
};
